import { Container, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchCandidate, deleteCandidate } from '../../../api/candidate';
import DeleteModal from '../../../components/deleteModal';
import Education from '../../../components/education';
import Experiences from '../../../components/experiences';
import Introduce from '../../../components/introduce';
import Loader from '../../../components/loader';
import Overview from '../../../components/overview';
import Quotes from '../../../components/quotes';
import Skills from '../../../components/skills';
import { COLORS } from '../../../constants/colors';
import useFetch from '../../../hooks/useFetch';
import useNotifications from '../../../hooks/useNotification';
import useDebounce from '../../../hooks/useDebounce';
import NotFoundPage from '../../404';
import PublicPage from '../../base/public';
import PdfDataExtractor from '../../../components/pdfDataExtractor';

const useStyles = makeStyles({
  root: {
    '& > section:nth-child(even)': {
      backgroundColor: COLORS.grayScale[1],
    },
  },
  container: {
    maxWidth: '90rem',
    padding: '2rem 3.125rem',
  },
  loader: {
    paddingTop: '3rem',
  },
});

const EditPage = () => {
  const classes = useStyles();
  const { hash } = useParams();
  const notifications = useNotifications();
  const history = useHistory();
  const [reload, setReload] = useState(false);
  const { isLoading, result: candidate } = useFetch(fetchCandidate, hash, [
    hash, reload
  ]);
  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [reloadUpdatedAt, setreloadUpdatedAt] = useState(false)
  const { result: candidateUpdatedAt } = useFetch(fetchCandidate, hash, [
    hash, reloadUpdatedAt
  ]);
  //const edit = true;

  const openModal = () => {
    setOpen(true);
    setDisabled(false);
  }

  const closeModal = () => {
    setOpen(false);
    setDisabled(false);
  }

  const handleCancel = useDebounce(() => {
    history.goBack();
  }, 1000);

  const handleDelete = useDebounce(() => {
    setDisabled(true);
    deleteCandidate(hash, { immediately: true })
      .then((res) =>
        res.success
          ? history.push('/candidates')
          : notifications.error(res.error)
      )
      .finally(() => {
        setDisabled(false);
      });
  }, 1000);

  const reloadCandidateUpdatedAtData = () => {
    setreloadUpdatedAt(!reloadUpdatedAt)
  }

  if (!isLoading && !candidate)
    return (
      <NotFoundPage message="The profile you are looking for is not available at the moment" />
    );

  return (
    <>
      <PublicPage withActions={true} onCancel={handleCancel} onDelete={openModal}>
        {isLoading && (
          <Loader className={classes.loader} label="Searching candidate ..." />
        )}
        {candidate && (
          <div className={classes.root}>
            <section>
              <Container className={classes.container}>
                <Introduce 
                  edit
                  {...candidate}
                  updatedAt={candidateUpdatedAt?.updatedAt}
                  reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData} 
                />
                <PdfDataExtractor hash={hash} setReload={setReload} reload={reload}/>
                <Skills 
                  title="Skills" 
                  edit
                  reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData} 
                />
                <Overview 
                  edit 
                  {...candidate}
                  reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData} 
                />
              </Container>
            </section>
            <section>
              <Container className={classes.container}>
                <Experiences reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData} edit />
              </Container>
            </section>
            <section>
              <Container className={classes.container}>
                <Education 
                  reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData} 
                  edit 
                />
                <Quotes
                  reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData} 
                  edit 
                />
              </Container>
            </section>
          </div>
        )}
      </PublicPage>
      <DeleteModal open={open} disabled={disabled} onClose={closeModal} onSubmit={handleDelete} />
    </>
  );
};

export default EditPage;
